import React from 'react';

import { useActingAsEntity } from '../hooks/useActingAsEntity';
import { Dialog, DialogBody, DialogTitle } from './dialog';
import { HealthcareEntitySearchList } from './healthcare-entity-search-list';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelected: () => void;
};

export const RequireActingAsEntityDialog: React.FC<Props> = ({ open, onClose, onSelected }) => {
  const { setActingAsEntity } = useActingAsEntity();

  return (
    <Dialog open={open} onClose={onClose} size="sm">
      <DialogTitle>Choose an organization</DialogTitle>
      <DialogBody>
        <p className="tw:text-sm tw:text-zinc-700 tw:mb-3">
          Select the organization you&apos;d like to act as for this action.
        </p>
        <HealthcareEntitySearchList
          /* eslint-disable-next-line jsx-a11y/no-autofocus */
          autoFocus
          onSelect={(entity) => {
            setActingAsEntity(entity);
            onClose();
            onSelected();
          }}
        />
      </DialogBody>
    </Dialog>
  );
};
